export default {
  panelContainer: {
    borderRadius: '5px',
    backgroundColor: '#f4f4f4',
    padding: '10px 15px',
    marginBottom: '15px',
    position: 'relative',
  },
  panelHeader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  panelHeaderLeft: {},
  panelHeaderRight: {
    display: 'flex',
    flexDirection: 'row',
    flex: 'none',
    justifyContent: 'center',
    alignItems: 'center'
  },
  panelHeaderTitle: {
    flex: 1,
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '14px',
    color: '#000'
  },
  panelCol: {
    marginRight: 5
  },
  panelHeaderButton: {
    margin: '0 5px'
  },
  panelHeaderArrow: {
    cursor: 'pointer',
    fontSize: 30,
    color: '#bebfc0',
    margin: '0 5px'
  },
  panelContent: {
    backgroundColor: '#fff',
    padding: 15,
    fontFamily: 'AvenirNext',
    fontWeight: 900,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    backgroundColor: '#fcfcfc',
    opacity: 0.5,
  },
  grayText: {
    color: '#96979a',
  },
  error: {
    padding: 5,
    textAlign: 'center',
    color: '#ff0000',
  }
}